import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';


@Injectable({providedIn: 'root'})
export class DomService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {
  }

  /* ---------- Full-Screen API ------------------------------------------- */
  enterFullscreen(el: HTMLElement = this.document.documentElement): Promise<void> {
    return el.requestFullscreen();
  }

  exitFullscreen(): Promise<void> {
    return this.document.exitFullscreen?.() ?? Promise.resolve();
  }

  toggleFullscreen(el: HTMLElement = this.document.documentElement): Promise<void> {
    return this.isFullscreen()
      ? this.exitFullscreen()
      : this.enterFullscreen(el);
  }

  isFullscreen(): boolean {
    return !!this.document.fullscreenElement;
  }
}
